import React from "react";
import SolLogo from '../CoinFlip/solana-sol-logo.png';
const BetValue = ()=>{
    return <>
    <div className="tossOption1">
      <input type="radio" id="f-3" name="selector1" className="selector-item_radio"/>
      <label for="f-3" className="selector-item_label cir"><img src={SolLogo} className="solanaIcon"/> 0.05</label>
    </div>
    <div className="tossOption1">
      <input type="radio" id="f-4" name="selector1" className="selector-item_radio"/>
      <label for="f-4" className="selector-item_label cir"><img src={SolLogo} className="solanaIcon"/> 0.1</label>
    </div>
    <div className="tossOption1">
      <input type="radio" id="f-5" name="selector1" className="selector-item_radio"/>
      <label for="f-5" className="selector-item_label cir"><img src={SolLogo} className="solanaIcon"/> 0.25</label>
    </div>
    <div className="tossOption1">
      <input type="radio" id="f-6" name="selector1" className="selector-item_radio"/>
      <label for="f-6" className="selector-item_label cir"><img src={SolLogo} className="solanaIcon"/> 0.5</label>
    </div>
    <div className="tossOption1">
      <input type="radio" id="f-7" name="selector1" className="selector-item_radio"/>
      <label for="f-7" className="selector-item_label cir"><img src={SolLogo} className="solanaIcon"/> 1</label>
    </div>
  </>
}

export default BetValue;